'use client';

import { ControlToggleButtonInputGroup } from '@/general/components/forms/Input/ControlInput/ControlToggleButtonInputGroup';
import { FC, useState } from 'react';

import { FilterOption, PlpFiltersConditionalProps } from '../../PlpFilters.type';
import { PlpFiltersRange, PricingMode } from './PlpFiltersRange';

type Props = {
  minCashOptions: FilterOption[];
  maxCashOptions: FilterOption[];
  minFinanceOptions: FilterOption[];
  maxFinanceOptions: FilterOption[];
  currentFilters: FilterOption[];
} & PlpFiltersConditionalProps;

const toggleOptions: { mode: PricingMode; label: string }[] = [
  { mode: 'cash', label: 'Cash' },
  { mode: 'finance', label: 'Finance' },
];

export const PlpFiltersRangePrice: FC<Props> = ({
  minCashOptions,
  maxCashOptions,
  minFinanceOptions,
  maxFinanceOptions,
  currentFilters,
  ...props
}) => {
  const defaultPricingMode =
    !currentFilters.length ||
    currentFilters.some(
      (filter) =>
        ['cashMin', 'cashMax'].includes(filter.filter) || !['financeMin', 'financeMax'].includes(filter.filter),
    )
      ? 'cash'
      : 'finance';
  const [pricingMode, setPricingMode] = useState<PricingMode>(defaultPricingMode);

  return (
    <div>
      <div className="mb-6">
        <ControlToggleButtonInputGroup
          id={`priceRange-${props.type}`}
          name="priceRange"
          value={pricingMode}
          onChange={(value) => setPricingMode(value)}
          options={toggleOptions.map((item) => ({ value: item.mode, label: item.label }))}
          buttonVariant="squared"
        />
      </div>
      {pricingMode === 'cash' && (
        <PlpFiltersRange
          minValue={currentFilters.find((filter) => filter.filter === 'cashMin')?.value}
          maxValue={currentFilters.find((filter) => filter.filter === 'cashMax')?.value}
          minOptions={minCashOptions.map((option) => ({
            ...option,
            label: option.label === 'All' ? 'Min price' : option.label,
          }))}
          maxOptions={maxCashOptions.map((option) => ({
            ...option,
            label: option.label === 'All' ? 'Max price' : option.label,
          }))}
          minPlaceholder="Min price"
          maxPlaceholder="Max price"
          {...props}
        />
      )}
      {pricingMode === 'finance' && (
        <PlpFiltersRange
          minValue={currentFilters.find((filter) => filter.filter === 'financeMin')?.value}
          maxValue={currentFilters.find((filter) => filter.filter === 'financeMax')?.value}
          minOptions={minFinanceOptions.map((option) => ({
            ...option,
            label: option.label === 'All' ? 'Min repayment' : option.label,
          }))}
          maxOptions={maxFinanceOptions.map((option) => ({
            ...option,
            label: option.label === 'All' ? 'Max repayment' : option.label,
          }))}
          minPlaceholder="Min repayment"
          maxPlaceholder="Max repayment"
          {...props}
        />
      )}
    </div>
  );
};
